export default __webpack_public_path__ + "static/media/combos@3x.c53c9869.png";